import { createRouter, createWebHistory } from 'vue-router'
import routes from '@/micro/router/index'
import { getCookie } from '../common/cookie'
import useMicrofront from '../composables/useMicrofront'
import { convertDictionaryToObject } from '../utils/appHelpers'
import useRouterGuards from '../composables/router/useRouterGuards'

const is_authenticated = getCookie('COOKIE_TOKEN')
const prefix = process.env.VUE_APP_ENVIROMENT == 'production' ? 'app' : 'hopper'
const prefixRedirect = process.env.VUE_APP_ENVIROMENT == 'production' ? '' : 'almost-'
const versionCache = localStorage.getItem('al-company-appVersion') ?? 'other'

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach(async (to, from, next) => {
  const { validateAuth, validateEmpty, validateVersion, redirectIsNotAuth } = useRouterGuards()

  if (validateAuth(to, is_authenticated)) {
    return redirectIsNotAuth(prefix, versionCache, prefixRedirect, to.name as string)
  }
  const { loadUserInfo, getUserData } = useMicrofront()

  if (Object.keys(getUserData()).length) return next()

  await loadUserInfo(convertDictionaryToObject())

  const version = localStorage.getItem('al-company-appVersion')

  if (validateVersion(to, version)) {
    console.log('no está en la ruta correcta')
    return next({
      name: 'nmsOptionContact',
      params: { version },
    })
  }
  if (validateEmpty(to)) {
    return next({
      name: 'nmsOptionContact',
      params: { version },
    })
  }
  next()
})
export default router
